import React, { useEffect, useState } from 'react'
import { Card, Input, Button, Table, Space, Pagination, Form, Avatar, Select, Row, Col, Checkbox, Drawer, Modal, message, Empty, Tag } from 'antd'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { getMyCustomerCountAPI, getMyCustomerListAPI, getLabelListAPI, getAllFollowUpUserListAPI, getDynamicListAPI, allocationCustomerAPI, getUserDetailAPI, addUserLabelAPI } from '@/apis/user'
import { getUserInfo } from '@/utils/token'
import { checkMenu, checkLogin, checkButton } from '@/utils'
import Dayjs from 'dayjs'
import styles from './customerList.module.scss'
import * as echarts from 'echarts'
const { Column } = Table
const { TextArea } = Input;

const distributionTabList = ['标记分布', '跟进人分布']
const quantityTabList = ['自然周', '自然月']
var myChart
var myChartPie

export default function ClueHouseList() {
  const navigate = useNavigate()
  const location = useLocation()
  const userinfo = getUserInfo()
  const [distributionTabIndex, setDistributionTabIndex] = useState(0)
  const [quantityTabIndex, setQuantityTabIndex] = useState(1)
  const [countData, setCountData] = useState({}) //  统计数据

  const [listLoading, setListLoading] = useState(false) //  表格加载状态
  //  列表请求参数
  const [listQuery, setListQuery] = useState({
    keywords: '',
    followUpUserId: undefined, //	跟进人筛选，-1：全部；0：没有跟进人；其他：指定跟进人用户编号
    labelId: undefined, //	标记筛选，0：未标记；
    pageInt: 1,
    pageSize: 100
  })
  const [total, setTotal] = useState(0) //  列表总数
  const [list, setList] = useState([]) //  获取列表
  const [labelList, setLabelList] = useState([]) // 标签列表
  const [userLabelList, setUserLabelList] = useState([]) // 增加标签列表
  const [userLabelForm, setUserLabelForm] = useState({
    labelId: undefined, //	标签编号
    remarks: '' //	备注
  }) // 标签编号
  const [searchFollowUpUserList, setSearchFollowUpUserList] = useState([]) // 全部跟进人列表
  const [followUpUserModal, setFollowUpUserModal] = useState(false) //  跟进人列表弹窗
  const [followUpUserList, setFollowUpUserList] = useState([]) // 全部跟进人列表
  const [allocationForm, setAllocationForm] = useState({
    originFollowUpUserId: 0, //	跟进人编号
    userId: 0, //	被分配用户编号
    followUpUserId: 0, //	跟进人编号
    followUpType: 0 //	分配状态；0：跟进人置空；1：分配跟进人
  })
  const [allocationLoading, setAllocationLoading] = useState(false) //  分配状态
  const [dynamicDrawer, setDynamicDrawer] = useState(false) // 动态抽屉
  // const [dynamicLoading, setDynamicLoading] = useState(false)// 动态加载状态
  const [dynamicUserId, setDynamicUserId] = useState(0) // 状态用户
  const [dynamicListQuery, setDynamicListQuery] = useState({
    pageInt: 1,
    pageSize: 10
  }) // 动态加载状态
  const [dynamicList, setDynamicList] = useState([]) // 动态列表
  const [dynamicTotal, setDynamicTotal] = useState([]) // 动态列表
  const [customerInfo, setCustomerInfo] = useState({}) // 客资信息
  const [monthChartData, setMonthChartData] = useState({
    titleList: [],
    dataList: []
  }) // 月度数据
  const [weekChartData, setWeekChartData] = useState({
    titleList: [],
    dataList: []
  }) // 周度数据
  const [labelChartData, setLabelChartData] = useState([]) // 标签数据
  const [pieChartEmpty, setPieChartEmpty] = useState(false) // 标签数据
  const [followUpChartData, setFollowUpChartData] = useState([]) // 跟进人数据
  const [chartEmpty, setChartEmpty] = useState(false) // 客资量数据


  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    console.log('%c [ selectedRows ]-72', 'font-size:13px; background:pink; color:#bf2c9f;', selectedRows)
    console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedUserIds(selectedRows?.map(item => item.userId))
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    selections: [
      Table.SELECTION_ALL,
      Table.SELECTION_INVERT,
      Table.SELECTION_NONE
    ],
  };


  //  我的客资统计数据
  const getMyCustomerCount = async () => {
    const res = await getMyCustomerCountAPI()
    if (res.success === true) {
      if (res.result) {
        let countData = {
          total: res.result.total,
          labelTotal: res.result.labelTotal,
          noLabelTotal: res.result.noLabelTotal,
          noFollowUpUserTotal: res.result.noFollowUpUserTotal
        }
        setCountData(countData)
        let labelList = []
        if(res.result.noLabelTotal > 0) {
          labelList.push({
            name: '已分配未标记',
            value: res.result.noLabelTotal
          })
        }
        if(res.result.labelList) {
          res.result.labelList.forEach(item => {
            if(item.userNum > 0) {
              labelList.push({
                name: item.name,
                value: item.userNum
              })
            }
          })
        }
        setLabelChartData(labelList)
        if(labelList.length > 0) {
          var option = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              show: false,
              orient: 'vertical',
              left: 'left'
            },
            series: [
              {
                name: '标记分布',
                type: 'pie',
                radius: '50%',
                data: labelList,
                label: {
                  formatter: '{b}  {c}'
                },
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                }
              }
            ]
          };
          option && myChartPie.setOption(option)
        } else {
          setPieChartEmpty(true)
        }
        
        let followUpList = []
        if(res.result.noFollowUpUserTotal > 0) {
          followUpList.push({
            name: '无跟进人',
            value: res.result.noFollowUpUserTotal
          })
        }
        if(res.result.followUpList) {
          res.result.followUpList.forEach(item => {
            if(item.userNum > 0) {
              followUpList.push({
                name: item.nickName,
                value: item.userNum
              })
            }
          })
        }
        setFollowUpChartData(followUpList)
      }
    } else {
      setPieChartEmpty(true)
    }
  }
  //  我的所有客资列表
  const getAllMyCustomerList = async () => {
    const res = await getMyCustomerListAPI({pageInt: 1, pageSize: 100000})
    if(res.success === true) {
      if (res.result && res.result.list.length > 0) {
        let year = new Date().getFullYear()
        let month = new Date().getMonth() + 1
        let day = new Date().getDate()
        let week = new Date().getDay()
        week = week === 0 ? 7 : week
        let monthList = []
        let monthObj = []
        for (let i = 0; i < 12; i++) {
          let thisMonth = month - i
          let thisYear = year
          if(month - i < 1) {
            thisYear = year - 1
            thisMonth = (month - i) + 12
          }
          monthList.push({
            text: thisYear + '年' + thisMonth + '月',
            startTime: new Date(thisYear + '/' + thisMonth + '/01 00:00:00').getTime(),
            num: 0
          })
          monthObj.push(new Date(thisYear, thisMonth - 1, 1).getTime())
        }
        let weekList = []
        let weekObj = []
        for (let i = 0; i < 20; i++) {
          let endTime = 0
          let startTime = 0
          if(i === 0) {
            endTime = new Date(year + '/' + month + '/' + day + ' 00:00:00').getTime()
            startTime = endTime - (week - 1) * 86400000
          } else {
            endTime = new Date(year + '/' + month + '/' + day + ' 00:00:00').getTime() - (week + (i - 1) * 7) * 86400000
            startTime = endTime - 6 * 86400000
          }
          weekList.push({
            text: Dayjs(startTime).format('MMDD') + '-' + Dayjs(endTime).format('MMDD'),
            startTime: startTime,
            num: 0
          })
          weekObj.push(startTime)
        }
        res.result.list.forEach(item => {
          let weekNum = Dayjs(item.addTime).format('d') || 7
          //  周
          let weekTime = new Date(Dayjs(item.addTime).format('YYYY/MM/DD') + ' 00:00:00').getTime() - (weekNum - 1) * 86400000
          let weekIndex = weekObj.indexOf(weekTime)
          if(weekIndex !== -1) {
            weekList[weekIndex].num++
          }
          //  月
          let monthTime = new Date(Dayjs(item.addTime).format('YYYY/MM') + '/01 00:00:00').getTime()
          let monthIndex = monthObj.indexOf(monthTime)
          if(monthIndex !== -1) {
            monthList[monthIndex].num++
          }
        })
        weekList.reverse()
        monthList.reverse()
        setWeekChartData({
          titleList: weekList.map(item => item.text),
          dataList: weekList.map(item => item.num)
        })
        setMonthChartData({
          titleList: monthList.map(item => item.text),
          dataList: monthList.map(item => item.num)
        })
        var option

        option = {
          color: ['#07C160'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              // Use axis to trigger tooltip
              type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
            }
          },
          xAxis: {
            type: 'category',
            data: monthList.map(item => item.text),
            axisLabel: {
              rotate: 45, // 设置旋转角度为 45 度
              margin: 20, // 可选：适当增加 margin 防止文字被截断
              fontSize: 12 // 可选：设置字体大小
            }
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: '客资量',
              data: monthList.map(item => item.num),
              type: 'bar',
              barWidth: 8
            }
          ]
        }

        option && myChart.setOption(option)
      } else {
        setChartEmpty(true)
      }
    } else {
      setChartEmpty(true)
    }
  }
  //  切换分布类型
  const changeDistributionTabs = index => {
    if(!checkLogin()) {
      setTimeout(() => {
        navigate('/')
      }, 2000)
      return
    }
    setPieChartEmpty(false)
    setDistributionTabIndex(index)
    let title = index ? '跟进人分布' : '标记分布'
    let dataList = index ? followUpChartData : labelChartData
    if(dataList.length === 0) {
      myChartPie.clear();
      setPieChartEmpty(true)
    } else {
      var option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          show: false,
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            name: title,
            type: 'pie',
            radius: '50%',
            data: dataList,
            label: {
              formatter: '{b}  {c}'
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      option && myChartPie.setOption(option)
    }
    
  }
  //  切换客流量类型
  const changeQuantityTabs = index => {
    if(!checkLogin()) {
      setTimeout(() => {
        navigate('/')
      }, 2000)
      return
    }
    setChartEmpty(false)
    setQuantityTabIndex(index)
    let dataList = index ? monthChartData.dataList : weekChartData.dataList
    let titleList =index ? monthChartData.titleList : weekChartData.titleList
    if(dataList.length === 0) {
      myChart.clear();
      setChartEmpty(true)
    } else {
      var option = {
        color: ['#07C160'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // Use axis to trigger tooltip
            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          data: titleList,
          axisLabel: {
            rotate: 45, // 设置旋转角度为 45 度
            margin: 20, // 可选：适当增加 margin 防止文字被截断
            fontSize: 12 // 可选：设置字体大小
          }
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '客资量',
            data: dataList,
            type: 'bar',
            barWidth: 8
          }
        ]
      }
      option && myChart.setOption(option)
    }
  }

  //  翻页
  const onChange = (page, pageSize) => {
    listQuery.pageInt = page
    listQuery.pageSize = pageSize
    setListQuery({
      ...listQuery,
      pageInt: page,
      pageSize: pageSize
    })
    fetchData()
  }
  //  搜索
  const searchFinish = values => {
    listQuery.keywords = values.keywords
    listQuery.followUpUserId = values.followUpUserId
    listQuery.labelId = values.labelId
    listQuery.pageInt = 1
    setListQuery({
      ...listQuery
    })
    fetchData()
  }
  // const changeFollowUpUser = e => {
  //   console.log('%c [ e ]-79', 'font-size:13px; background:pink; color:#bf2c9f;', e)
  //   listQuery.followUpUserId = e.target.checked === true ? 0 : -1
  //   listQuery.pageInt = 1
  //   console.log('%c [ listQuery ]-103', 'font-size:13px; background:pink; color:#bf2c9f;', listQuery)
  //   setListQuery({
  //     ...listQuery,
  //     pageInt: 1
  //   })
  //   fetchData()
  // }

  //  获取客资列表
  const fetchData = async () => {
    if(!checkLogin()) {
      setTimeout(() => {
        navigate('/')
      }, 2000)
      return
    }
    setListLoading(true)
    listQuery.followUpUserId = listQuery.followUpUserId >= 0 ? listQuery.followUpUserId : -1
    listQuery.labelId = listQuery.labelId >= 0 ? listQuery.labelId : -1
    const res = await getMyCustomerListAPI(listQuery)
    if (res.success === true) {
      if (res.result.list) {
        res.result.list.forEach((item, index) => {
          item.key = index
          item.addTime = Dayjs(item.addTime).format('YYYY-MM-DD')
          item.followUpNickName = decodeURIComponent(item.followUpNickName)
          item.nickName = item.nickName ? item.nickName : '暂无昵称' + item.userId.toString().slice(-4)
        })
      }
      setList(res.result.list)
      setTotal(res.result.total)
    }
    setListLoading(false)
  }
  //  获取标签列表
  const getLabelList = async () => {
    const res = await getLabelListAPI()
    if (res.success === true) {
      if (res.result && res.result.list) {
        let labelList = []
        let userLabelList = []
        let labelPNames = []
        res.result.list.forEach(item => {
          labelList.push({
            value: item.id,
            label: item.name
          })
          let index = labelPNames.indexOf(item.categoryName)
          if(index === -1) {
            labelPNames.push(item.categoryName)
            userLabelList.push({
              name: item.categoryName,
              list: [item],
            })
          } else {
            userLabelList[index].list.push(item)
          }
        })
            console.log('%c [ userLabelList ]-469', 'font-size:13px; background:pink; color:#bf2c9f;', userLabelList)
        setLabelList(labelList)
        setUserLabelList(userLabelList)
      }
    }
  }
  //  获取全部跟进人列表
  const getAllFollowUpUserList = async () => {
    const res = await getAllFollowUpUserListAPI()
    if (res.success === true) {
      let searchFollowUpUserList = []
      let followUpUserList = []
      res.result?.list?.forEach(item => {
        if(item.status === 1) {
          searchFollowUpUserList.push({
            value: item.userId,
            label: item.nickName
          })
          followUpUserList.push(item)
        }
      })
      setSearchFollowUpUserList(searchFollowUpUserList)
      setFollowUpUserList(followUpUserList)
    }
  }
  //  显示客资动态列表
  const showDynamicList = async userId => {
    //setDynamicLoading(true)
    setDynamicUserId(userId)
    getCustomerDetail(userId)
    const res = await getDynamicListAPI({ userId, ...dynamicListQuery })
    if (res.success === true) {
      if (res.result.list) {
        res.result.list.forEach((item) => {
          item.operateNickName = decodeURIComponent(item.operateNickName)
          item.operateTime = Dayjs(item.operateTime).format('YYYY-MM-DD HH:mm')
        })
      }
      setDynamicList(res.result.list)
      setDynamicTotal(res.result.total)
      //setDynamicLoading(false)
      setDynamicDrawer(true)
    }
  }
  //  客资信息
  const getCustomerDetail = async (userId) => {
    const res = await getUserDetailAPI({ userId })
    if (res.success === true) {
      if (res.result) {        
          res.result.nickName = res.result.nickName ? decodeURIComponent(res.result.nickName) : '暂无昵称' + userId.toString().slice(-4)
        
      }
      setCustomerInfo(res.result)
    }
  }
  //  翻页
  const onDynamicChange = (page, pageSize) => {
    dynamicListQuery.pageInt = page
    dynamicListQuery.pageSize = pageSize
    setDynamicListQuery({
      ...dynamicListQuery,
      pageInt: page,
      pageSize: pageSize
    })
    showDynamicList()
  }
  //  关闭抽屉
  const closeDynamicDrawer = () => {
    setDynamicDrawer(false)
  }
  //  标记标签变更
  const changeLabel = async (id) => {
    userLabelForm.labelId = id
    setUserLabelForm({
      ...userLabelForm,
      labelId: id
    })
  }
  //  标记标签备注变更
  const changeLabelRemarks = (e) => {
    userLabelForm.remarks = e.target.value
    setUserLabelForm({
      ...userLabelForm,
      remarks: e.target.value
    })
  }
  //  新增标签
  const submitLabel = async () => {
    const res = await addUserLabelAPI({ userId: dynamicUserId, ...userLabelForm })
    if (res.success === true) {
      message.success('添加成功')
      userLabelForm.labelId = undefined
      userLabelForm.remarks = ''
      setUserLabelForm({
        ...userLabelForm,
        labelId: undefined,
        remarks: ''
      })
      showDynamicList(customerInfo.userId)
    }
  }
  //  显示跟进人弹窗
  const showFollowUpUserModal = (user) => {
    let allocationForm = {
      originFollowUpUserId: user.followUpUserId || 0,
      userId: user.userId,
      followUpUserId: user.followUpUserId || 0,
      type: 0,
    }
    setAllocationForm(allocationForm)
    setFollowUpUserModal(true)
  }
  //  批量分配跟进人
  const showAllFollowUpUserModal = () => {
    if(selectedUserIds.length === 0){
      message.error('请选择用户')
      return
    }
    let allocationForm = {
      originFollowUpUserId: 0,
      userId: selectedUserIds.join(","),
      followUpUserId: 0,
      type: 1
    }
    setAllocationForm(allocationForm)
    setFollowUpUserModal(true)
  }
  //  关闭跟进人弹窗
  const closeFollowUpUserModal = () => {
    setFollowUpUserModal(false)
  }
  //  变更分配的跟进人
  const changeAllocationFollowUpUser = (e) => {
    setAllocationForm({
      ...allocationForm,
      followUpUserId: e,
      followUpType: e === 0 ? 0 : 1
    })
  }
  //  分客
  const allocationFollowUpUser = () => {
    setAllocationLoading(true)
    if(allocationForm.type == 0 && allocationForm.originFollowUpUserId == allocationForm.followUpUserId) {
      message.error('跟进人未变更')
      return false
    }
    
    let params = {
      userId: allocationForm.userId, 
      followUpUserId: allocationForm.followUpType === 0 ? allocationForm.originFollowUpUserId : allocationForm.followUpUserId,
      followUpType: allocationForm.followUpType || 0
    }
    allocationCustomerAPI(params).then((res) => {
      if (res.success === true) {
        message.success(res.message || '分配成功')
        fetchData()
        getAllFollowUpUserList()
        setFollowUpUserModal(false)
        setSelectedRowKeys([])
        setSelectedUserIds([])
      } else {
        message.error(res.message)
      }
      setAllocationLoading(false)
    })
  }

  useEffect(() => {
    if(!checkMenu(location.pathname)) {
      navigate('/managecenter/404')
      return
    }
    var chartDom = document.getElementById('echarts-bar')
    myChart = echarts.init(chartDom)
    var chartPieDom = document.getElementById('echarts-pie')
    myChartPie = echarts.init(chartPieDom)
    getMyCustomerCount()
    fetchData()
    getLabelList()
    getAllFollowUpUserList()
    getAllMyCustomerList()
  }, [])

  return (
    <div>
      <div className="pageTitle">
        <div className="pageTitle-name">我的客资</div>
        <div className="font-size14">
          <span>累计{countData.total}</span>
          <span className="gray">
            ：已标记<span className="green">{countData.labelTotal}</span>，已分配未标记<span className="red">{countData.noLabelTotal}</span>，无跟进人<span className="purple">{countData.noFollowUpUserTotal}</span>
          </span>
        </div>
      </div>
      <Row>
        <Col span={12}>
          <Card className="card">
            <div className="card-title">
              <div className="card-txt">我的客资分布</div>
              <div className="housedetail-signtabs">
                {distributionTabList.map((item, index) => {
                  return (
                    <div className={index == distributionTabIndex ? 'housedetail-signtabs-item housedetail-signtabs-item-active' : 'housedetail-signtabs-item'} key={index} onClick={() => changeDistributionTabs(index)}>
                      {item}
                    </div>
                  )
                })}
              </div>
            </div>
            { pieChartEmpty ? (
              <div style={{ height: '268px' }}>
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              </div>
            ) : ''}
            <div id="echarts-pie" style={{ width: '100%', height: pieChartEmpty ? '0px' : '300px' }} />
          </Card>
        </Col>
        <Col span={12}>
          <Card className="card" style={{ marginLeft: 0 }}>
            <div className="card-title">
              <div className="card-txt">客资量走势</div>
              <div className="housedetail-signtabs">
                {quantityTabList.map((item, index) => {
                  return (
                    <div className={index == quantityTabIndex ? 'housedetail-signtabs-item housedetail-signtabs-item-active' : 'housedetail-signtabs-item'} key={index} onClick={() => changeQuantityTabs(index)}>
                      {item}
                    </div>
                  )
                })}
              </div>
            </div>
            { chartEmpty ? (
              <div style={{ height: '268px' }}>
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              </div>
            ) : ''}
            <div id="echarts-bar" style={{ width: '100%', height: chartEmpty ? '0px' : '300px' }} />
          </Card>
        </Col>
      </Row>
      <Card className="card">
        <div className="flex-between">
          <Form initialValues={listQuery} onFinish={searchFinish} className="searchForm">
            <Form.Item name="keywords">
              <Input allowClear placeholder="用户昵称" style={{ width: '200px' }} />
            </Form.Item>
            <Form.Item name="followUpUserId">
              <Select allowClear options={searchFollowUpUserList} placeholder="跟进人" style={{ width: '250px', marginLeft: '10px' }} />
            </Form.Item>
            <Form.Item name="labelId">
              <Select allowClear showSearch placeholder="标记" optionFilterProp="label" options={labelList} style={{ width: '250px', marginLeft: '10px' }} />
            </Form.Item>
            <Form.Item>
              <Button type="primary" className="searchBtn" htmlType="submit" style={{ marginLeft: '10px' }}>
                搜索
              </Button>
            </Form.Item>
            <Form.Item>
              <Button type="primary" onClick={showAllFollowUpUserModal} style={{ marginLeft: '10px' }}>
                批量分客
              </Button>
            </Form.Item>
          </Form>
          {/* <div>
            <Checkbox checked={listQuery.followUpUserId === 0} onChange={changeFollowUpUser}>只看跟进人为空</Checkbox>
          </div> */}
        </div>

        <Table rowSelection={rowSelection} dataSource={list} loading={listLoading} pagination={false}>
          <Column
            title="头像/昵称"
            render={(_, record) => (
              <Space size="middle">
                <Avatar shape="square" size={24} draggable={false} src={record.avatar ? record.avatar + '?x-oss-process=image/resize,w_24,m_lfit' : '/images/avatar.png'} />
                {record.nickName}
              </Space>
            )}
          />
          <Column
            title="标签"
            key="labelList"
            render={(_, record) => (
              <div>
                {record.labelList && record.labelList.map((item, index) => {
                  return (
                    <div className={index < record.labelList.length - 1 ? 'padding-bottom-10' : ''} key={index}>
                      <Tag>{item.tagName}</Tag>
                    </div>
                  )
                })}
              </div>
            )}
          />
          <Column title="收为客资" dataIndex="customerNum" />
          <Column title="电话" dataIndex="mobile" />
          <Column
            title="当前跟进人"
            render={(_, record) => (
              record.followUpUserId ? (
                <div>
                  <div>{record.followUpNickName}</div>
                  <div className="red">{record.clickPhoneNum > 0 ? '（电话*' + record.clickPhoneNum + '）' : ''}</div>
                </div>
              ) : ''
            )}
          />
          <Column title="最新标记" dataIndex="newLabelName" />
          <Column title="添加时间" dataIndex="addTime" />
          <Column
            title="操作"
            key="action"
            render={(_, record) => (
              <Space size="middle">
                <Link target="_blank" to={'/managecenter/user/detail/' + record.userId} className="color-576b95">
                  画像
                </Link>
                <Button type="link"  onClick={() => showDynamicList(record.userId)} className="color-576b95">
                  跟进动态
                </Button>
                <Button type="link" onClick={() => showFollowUpUserModal(record)} className="color-576b95">
                  分客
                </Button>
              </Space>
            )}
          />
        </Table>
        <Pagination hideOnSinglePage defaultPageSize={20} showTotal={total => '共 ' + total + ' 条数据'} pageSize={listQuery.pageSize} pageSizeOptions={['10', '20', '30', '50', '100']} total={total} showSizeChanger showQuickJumper onChange={onChange} />
      </Card>
      <Modal title="分客" closable={false} open={followUpUserModal} onOk={allocationFollowUpUser} onCancel={closeFollowUpUserModal} footer={[
          <Button key="back" onClick={closeFollowUpUserModal}>取消</Button>,
          <Button key="submit" type="primary" loading={allocationLoading} onClick={allocationFollowUpUser}>确定</Button>
        ]}>
        <div className={styles['followUpUser-item']}>
          <div className={styles['info']}>
            <div className={styles['name']}>置空跟进人</div>
          </div>
          <div className={styles['checkbox']}>
            <Checkbox checked={allocationForm.followUpUserId === 0} onChange={() => changeAllocationFollowUpUser(0)} />
          </div>
        </div>
        {followUpUserList.map((item, index) => {
          return (
            <div className={styles['followUpUser-item']} key={index}>
              <div className={styles['info']}>
                <Avatar shape="square" size={24} draggable={false} src={item.avatarUrl} />
                <div className={styles['name']}>{item.nickName}</div>
                {(item.customerNum - item.labelNum) >= item.allowNoLabelUserNum && <div className={styles['label']}>分配受限</div>}
              </div>
              <Checkbox checked={item.userId === allocationForm.followUpUserId} disabled={(item.customerNum - item.labelNum) >= item.allowNoLabelUserNum} onChange={() => changeAllocationFollowUpUser(item.userId)} />
            </div>
          )
        })}
      </Modal>
      <Drawer closeIcon={false} open={dynamicDrawer} onClose={closeDynamicDrawer}>
        <div className={styles['dynamic-top']}>
          <div className={styles['userinfo']}>
            <img src={customerInfo.avatarUrl || '/images/avatar.png'} className={styles['avatar']} />
            <span className={styles['nickname']}>{customerInfo.nickName}</span>
          </div>
          <div className={styles['close']} onClick={closeDynamicDrawer}>
            关闭
          </div>
        </div>

        <div className={styles['info-item']}>
          客资归属：<span className="font-normal">{decodeURIComponent(userinfo.userName)}（PC账号）</span>
        </div>
        <div className={styles['info-item']}>
          当前跟进人：<span className="font-normal">{customerInfo.followUpNickName}</span>
        </div>
        <div className={styles['info-item']}>
          最新标记：<span className="font-normal red">{customerInfo.newLabelName}</span>
        </div>
        {checkButton('customerlist.addlabel') && (
          <div>
            <div className={styles['dynamic-title']}>新增标记</div>
            <div className={['font-size14', styles['label-list']].join(' ')}>
              {userLabelList.map((item, index) => {
                return (
                  <div className={styles['label-item']} key={index}>
                    <div className={['gray', 'margin-top-12', styles['label-pname']].join(' ')}>{item.name}：</div>
                    <div className={['flex', 'line-height-24', styles['label-child']].join(' ')}>
                      {item.list.map((ele, k) => {
                        return (
                          <div className={['margin-right-16', 'margin-top-12', 'white-space-nowrap', 'cursor-pointer', (userLabelForm.labelId == ele.id ? 'green' : ''), styles['label-child-item']].join(' ')} key={k} onClick={() => changeLabel(ele.id)}>{ele.name}</div>
                        )
                      })}
                    </div>
                  </div>
                )
              })}
              
              <div className={['gray', 'margin-top-12', styles['label-pname']].join(' ')}>附加说明：</div>
              <TextArea value={userLabelForm.remarks} className={['margin-top-12', styles['label-textarea']].join(' ')} rows={4} placeholder="选填，对本次标记的附加说明…200字以内" maxLength={6} onChange={changeLabelRemarks} />
              <Button type="primary" className={['margin-top-12', styles['labelBtn']].join(' ')} size="large" onClick={submitLabel}>确认提交</Button>
            </div>
          </div>
        )}
        
        <div className={styles['dynamic-title']}>用户跟进动态</div>
        {dynamicList.length === 0 ? (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        ) : (
          <div className={styles['dynamic-list']}>
            {dynamicList.map((item, index) => {
              return (
                <div className={styles['dynamic-item']} key={index}>
                  <div className={styles['time']}>[{item.type == 2 ? '标记' : (item.type == 1 ? '置空' : '分客')}]{item.operateTime}</div>
                  {item.type == 2 ? (
                    <div className={styles['content']}>{item.operateNickName}将用户“{customerInfo.nickName}”标记为“<span className="red">{item.labelName}</span>”</div>
                  ) : (
                    item.type == 1 ? (
                      <div className={styles['content']}>{item.remark}</div>
                    ) : (
                      <div className={styles['content']}>{item.operateNickName}将用户“{customerInfo.nickName}”{item.followUpUserId === 0 ? '跟进人置空' : '分客给“' + item.followUpNickName + '”'}</div>
                    )
                    
                  )}
                  { (item.remark && item.type == 2) && <div className={styles['remark']}>{item.remark}</div>}
                  <div className={styles['admin']}>操作人：{item.operateNickName}（{item.platform ? '小程序账号' : 'pc账号'}）</div>
                </div>
              )
            })}
          </div>
        )}
        
        <Pagination
          hideOnSinglePage
          defaultPageSize={20}
          showTotal={dynamicTotal => '共 ' + dynamicTotal + ' 条数据'}
          pageSize={dynamicListQuery.pageSize}
          pageSizeOptions={['10', '20', '30', '50', '100']}
          total={dynamicTotal}
          showSizeChanger
          showQuickJumper
          onChange={onDynamicChange}
        />
      </Drawer>
    </div>
  )
}
